import React from 'react';
import PropTypes from 'prop-types';
// styles
import cx from 'classnames';
import styled from 'styled-components';
// logic
import { useTranslation } from 'react-i18next';
import { useOrderStop } from 'components/orders/OrderStop/UseOrderStop';
import { getGroupedNumberPalletsFormattedArray } from 'utils/loads/formatters/getGroupedNumberPalletsFormatted';
// components
import { LoadTypeLoadIcon, LoadTypeUnloadIcon } from 'refactored/ui/icons';

const LoadsSummaryTable = ({ className, loads }) => {
  const { stopType } = useOrderStop();

  const { t } = useTranslation('loads');

  const loadsArray = getGroupedNumberPalletsFormattedArray({
    loads,
    t,
  });
  const stopTypeLabel = t(`${stopType}_of`);

  return (
    <div className={cx(className, 'load-info')}>
      <div className="load-header">
        {stopType === 'pickup' && <LoadTypeLoadIcon />}
        {stopType === 'dropoff' && <LoadTypeUnloadIcon />}
        {stopTypeLabel}
      </div>
      <div className="loads-table">
        <table>
          <tbody>
            {loadsArray.map((loadRow) => (
              <tr key={JSON.stringify(loadRow)}>
                <td>{loadRow.sizes}</td>
                <td>{loadRow.height} cm</td>
                <td>{loadRow.weight} kg</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

LoadsSummaryTable.propTypes = {
  className: PropTypes.string,
  loads: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default styled(LoadsSummaryTable)`
  &.load-info {
    line-height: 24px;
    font-size: 16px;
    color: var(--grey700);
    .load-header {
      margin-bottom: 7px;
      display: flex;
      align-items: center;
      svg {
        margin-right: 8px;
      }
    }
    .loads-table {
      padding-left: 28px;
      padding-right: 3px;
      table {
        width: 100%;
        border-collapse: collapse;
        tr {
          td {
            border-top: 1px solid var(--grey300);
          }
          td:first-child {
          }
        }
        tr:first-child {
          td {
            border: none;
          }
        }
        td {
          width: 25%;
          text-align: right;
          padding: 5px;
        }
        td:first-child {
          width: 50%;
          text-align: left;
        }
      }
    }
  }
`;
